import 'tinymce/plugins/autoresize';
export const MCE_AUTORESIZE = 'autoresize';